var exports = {
  "kL": "xaf9ae18d--677f9e--container",
  "Qq": "xaf9ae18d--677f9e--text",
  "Fk": "xaf9ae18d--677f9e--info-icon",
  "TS": "xaf9ae18d--677f9e--rate",
};

module.exports = exports;
